import ReactDOM from "react-dom/client";
import "./index.css";
import "@mantine/core/styles.css";
import "antd/dist/reset.css";
import { AppWrapper } from "./AppWrapper";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<AppWrapper />);
